const TWO_DECIMAL_OPTIONS = {minimumFractionDigits: 2, maximumFractionDigits: 2};

const toNumber = (value) => {
    if (value === null || value === undefined || value === '') return NaN;
    if (typeof value === 'number') return value;
    return parseFloat(String(value).replace(/,/g, ''));
};

export const formatMoney = (value, currency = null) => {
    const amount = toNumber(value);
    if (!Number.isFinite(amount)) return '';

    if (currency) {
        return new Intl.NumberFormat(undefined, {
            style: 'currency',
            currency,
            ...TWO_DECIMAL_OPTIONS,
        }).format(amount);
    }

    return `$ ${new Intl.NumberFormat(undefined, TWO_DECIMAL_OPTIONS).format(amount)}`;
};

export default formatMoney;
